import { connect } from 'react-redux'

import { changeTicketCategory } from '../../../../reducer'

const hocYourOrder = (InnerComponent) => connect(null, { changeTicketCategory })(InnerComponent)

export default hocYourOrder
